import { Button, styled, Table, Text } from '@/theme/index';

export const StyledText = styled(Text)(({ theme }) => ({
  textAlign: 'left',

  [theme.breakpoints.up('sm')]: {
    textAlign: 'right',
  },
}));

export const StyledImg = styled('img')(({ theme }) => ({
  cursor: 'pointer',
  height: '20px',
  [theme.breakpoints.up('sm')]: {
    height: '30px',
  },
}));

export const StyledTable = styled(Table)(({ theme }) => ({
  tbody: {
    tr: {
      td: {
        width: '50%',
        fontSize: theme.spacing(2),
        padding: theme.spacing(2),
        whiteSpace: 'pre-line',
      },
    },
    td: {
      position: 'relative',
      '&:nth-of-type(odd)': {
        fontWeight: 'bold',
        textAlign: 'end',
      },
    },
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',

  [theme.breakpoints.up('sm')]: {
    width: '175px',
  },
}));
